import { useApiInspectionsV1List } from 'api';

export const useAllDealInspections = (dealId: number) => {
  return useApiInspectionsV1List(
    {
      deal_id: dealId,
      page_size: 10000,
    },
    {
      query: {
        enabled: !!dealId,
      },
    }
  );
};
